export const convertToDataUrl = async (file: any[]) => {
  return new Promise(async resolve => {
    let arr = [];
    for (let i = 0; i < file.length; i++) {
      const fr = new FileReader();
      fr.onload = () => {
        arr.push(fr.result);

        if (arr.length === file.length) resolve(arr);
      };

      fr.readAsDataURL(file[i]);
    }
  });
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};
